import { type PayloadAction } from "../../../../../interfaces/redux";
import { createReducer } from "../../../../../utils/reduxUtils";
import { commonActionTypes } from "../actionTypes/commonSurveyActionTypes";
import { actionTypes } from "../actionTypes/surveyContentValidationActionTypes";

export interface SurveyContentValidationState {
  initialized: boolean;
  isFormValid?: boolean;
  errorMode: boolean;
  activeErrors: { [key: string]: string };
  touchedSnapshot: object;
  resolved: boolean;
}

export const initialState: SurveyContentValidationState = {
  initialized: false,
  isFormValid: undefined,
  errorMode: false,
  activeErrors: {},
  resolved: true,
  touchedSnapshot: {},
};

const surveysContentValidationHandlers = () => {
  const handleSetIsValid = (
    state: SurveyContentValidationState,
    action: PayloadAction<boolean>,
  ): SurveyContentValidationState => {
    return {
      ...state,
      isFormValid: action.payload,
    };
  };

  const handleSetErrorMode = (
    state: SurveyContentValidationState,
    action: PayloadAction<boolean>,
  ): SurveyContentValidationState => {
    return {
      ...state,
      errorMode: action.payload,
    };
  };
  const handleSetResolved = (
    state: SurveyContentValidationState,
    action: PayloadAction<boolean>,
  ): SurveyContentValidationState => {
    return {
      ...state,
      resolved: action.payload,
    };
  };

  const handleSetInitialized = (
    state: SurveyContentValidationState,
    action: PayloadAction<boolean>,
  ): SurveyContentValidationState => {
    return {
      ...state,
      initialized: action.payload,
    };
  };

  const handleSetActiveErrors = (
    state: SurveyContentValidationState,
    action: PayloadAction<{ [key: string]: string }>,
  ): SurveyContentValidationState => {
    return {
      ...state,
      activeErrors: action.payload,
    };
  };

  const handleSetTouchedSnapshot = (
    state: SurveyContentValidationState,
    action: PayloadAction<object>,
  ): SurveyContentValidationState => {
    return {
      ...state,
      touchedSnapshot: action.payload,
    };
  };

  const handlerReset = () => ({
    ...initialState,
  });

  const handleDiscard = (state: SurveyContentValidationState): SurveyContentValidationState => ({
    ...state,
    errorMode: false,
  });

  return {
    [actionTypes.setIsValid]: handleSetIsValid,
    [actionTypes.setActiveErrors]: handleSetActiveErrors,
    [actionTypes.setErrorMode]: handleSetErrorMode,
    [actionTypes.setResolved]: handleSetResolved,
    [actionTypes.setInitialized]: handleSetInitialized,
    [actionTypes.setTouchedSnapshot]: handleSetTouchedSnapshot,
    [actionTypes.reset]: handlerReset,
    [commonActionTypes.discard]: handleDiscard,
  };
};

export const surveysContentValidationReducer = createReducer(initialState, [surveysContentValidationHandlers]);
